import React, { useRef, useState } from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import Link from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
import LinearProgress from '@material-ui/core/LinearProgress';
import Alert from '@material-ui/lab/Alert';
import { useDispatch, useSelector } from "react-redux";
import { submit } from 'redux-form';

import * as LoginActions from '../actions/Login';
import * as RegistrationActions from '../actions/Registration';
import * as ProfileActions from '../actions/Profile';
import * as EventActions from '../actions/Event';

import ProfileForm from './ProfileForm';


export default function RegistrationDialog() {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  let inProgress = useSelector(state => state.registration.inProgress);
  let open = useSelector(state => state.event.showRegister);
  let initialValues = useSelector(state => state.profile.data);
  let eventQuestions = useSelector(state => state.event.questions);
  let failedAnswers = useSelector(state => state.profile.failedAnswers);
  let eventTitle = useSelector(state => state.event.data.title);

  const dispatch = useDispatch();
  const onClose = () => dispatch(EventActions.hideRegisterModal());
  const onSubmit = (values) => {
    console.log("Submit reg", values);
    dispatch( RegistrationActions.doRegister(values));
  }

  const onRegister = () => {
    dispatch( submit('profile') );
  }

  const renderFailed = () => {
    return (<Typography variant='body1'>Thanks for your interest in the {eventTitle}. Unfortunately, based on your responses to the registration questions, you don't currently meet the criteria to attend the event.<br/>Since you haven't meet the registration criteria, we will not save your information. However, we encourage you to check out our other virtual recruiting events in the future.</Typography>);
  };

  return (
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={onClose}
        aria-labelledby="reg-dialog-title"
        scroll="body"
      >
        <DialogTitle id="reg-dialog-title" style={{paddingBottom: 0}}>Register to attend</DialogTitle>
        <DialogContent>
          <DialogContentText component='div' >
            { failedAnswers ? renderFailed() :
            (<>
            <ProfileForm hideButtons={true}
              showEventQuestion={true}
              questions={eventQuestions}
              initialValues={initialValues}
              profile={initialValues}
              onSubmit={onSubmit} />
            <div style={{marginBottom: 20}}>
              <small>By registering I agree to the <Link href='https://www.recruitvirtual.com/privacy-and-terms' rel="noopener" target='_blank'>Privacy &amp; Terms</Link> and to receive confirmation via text message. Message &amp; data rates may apply. Opt out anytime with STOP.</small>
            </div>
            </>) }
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="inherit">
            Close
          </Button>
          <Button variant="contained" disabled={inProgress || failedAnswers}
            onClick={onRegister}
            color="primary"
            autoFocus>
            Register
          </Button>
        </DialogActions>
        {inProgress ? <LinearProgress /> : '' }
      </Dialog>
  );
}
